import { render, staticRenderFns } from "./ClassroomVideoMultiple.vue?vue&type=template&id=fc666208&"
import script from "./ClassroomVideoMultiple.vue?vue&type=script&lang=js&"
export * from "./ClassroomVideoMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports